/**
 * DevExtreme (esm/events/double_click.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    name,
    dblClick
} from "../__internal/events/dblclick";
import registerEvent from "./core/event_registrator";
registerEvent(name, dblClick);
export {
    name
};
